import {
  HeadItemType,
  Pagination as TablePagination,
  Table,
  ITEMS_PER_PAGE,
  type PaginationParams
} from 'components'

import * as S from './styles'
import { type LeadTimesData } from 'services/leadTimes'

const headDataLeadTimes: HeadItemType[] = [
  { label: 'Material', columnName: 'material' },
  { label: 'Descrição', columnName: 'description' },
  { label: 'Tecnologia', columnName: 'technology' },
  { label: 'Padrão', columnName: 'leadTime' },
  { label: 'Key Accounts', columnName: 'keyAccountsTime' }
]

interface LeadTimesTableProps {
  data: LeadTimesData[]
  pagination: PaginationParams
  setCurrentPage: (page: number) => Promise<void>
  disabled?: boolean
}

export const LeadTimesTable: React.FC<LeadTimesTableProps> = ({
  pagination,
  data,
  setCurrentPage,
  disabled = false
}) => {
  if (!data) {
    return null
  }

  const renderBody = () => {
    return data.map((item) => {
      const key = `${item.material}-${item.description}-${item.technology}-${item.leadTime}`

      return {
        id: `id-${key}`,
        content: [
          <span key={`Material-${key}`}>{item.material}</span>,
          <span key={`Description-${key}`}>{item.description}</span>,
          <span key={`Technology-${key}`}>{item.technology}</span>,
          <span key={`LeadTime-${key}`}>
            {item.leadTime} dia{item.leadTime !== 1 && 's'}
          </span>,
          <span key={`KeyAccountsTime-${key}`}>
            {item.keyAccountsTime} dia{item.keyAccountsTime !== 1 && 's'}
          </span>
        ]
      }
    })
  }

  const headData = headDataLeadTimes

  return (
    <S.Container>
      <Table headData={headData} bodyData={renderBody()} rowHeight={40} fixedHead />
      <S.Divider />
      <TablePagination
        disabled={disabled}
        currentPage={pagination?.currentPage}
        numberOfItems={pagination?.totalItems}
        itemsPerPage={ITEMS_PER_PAGE}
        setCurrentPage={setCurrentPage}
      />
    </S.Container>
  )
}
